const createLoaderStub = ($el) => {
  const $loader = document.createElement('span');
  $loader.className = 'loader-overlay';
  $loader.innerHTML = '<span class="loader-img"></span>';
  document.querySelector($el).prepend($loader);
};
export default createLoaderStub;
